import { render, staticRenderFns } from "./TabCompanies.vue?vue&type=template&id=75debc68&scoped=true"
import script from "./TabCompanies.vue?vue&type=script&lang=js"
export * from "./TabCompanies.vue?vue&type=script&lang=js"
import style0 from "./TabCompanies.vue?vue&type=style&index=0&id=75debc68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75debc68",
  null
  
)

export default component.exports